module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bv-adee14dc818c2a37dbd9f73c21e61ce1.svg";